module.exports = __webpack_public_path__ + "img/logo.b2e588a3.png";